export default __webpack_public_path__ + "static/media/700.7642fe3f.gif";